import { createFileRoute, redirect } from "@tanstack/react-router";
import GoogleMapComponent from "~/components/GoogleMap";
import { fetchUserServer } from "~/lib/services/user";
import { useUser } from "~/lib/services/user-frontend";

export const Route = createFileRoute("/")({
  component: Home,
  loader: async () => {},
});

function Home() {
  const { data: user } = useUser();

  return (
    <div>
      <GoogleMapComponent />
    </div>
  );
}
